module.exports = __webpack_public_path__ + "static/media/V_pictos-03.20933274.svg";